<template>
  <div class="bounties-overview-container">
    <slot />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
$grid-column: 133px;

.bounties-overview-container {
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr;
  min-height: 50px;
  position: relative;
}

@media(min-width: 460px) {
  .bounties-overview-container {
    grid-template-columns: repeat(auto-fit, minmax(calc($grid-column * 3), 1fr));
  }
}
</style>
